export default __webpack_public_path__ + "static/media/SY.35e61670.svg";